import { STATE_INITIAL } from 'Store/commonActions';

import type { TinderSelectState } from './types';

const initialState: TinderSelectState = {
  onboardingStatusResponse: null,
  isUnlockCodeValidated: false,
  completeTinderSelectOnboardingStatus: STATE_INITIAL,
  fetchOnboardingStatusState: STATE_INITIAL,
  landingPageSeen: false,
  unlockCodeStatusState: STATE_INITIAL,
  packageSelectionProductId: '',
  validateFetchSelectOfferingsStatus: STATE_INITIAL,
  userInflowType: null,
};

export default initialState;
